import gql from "graphql-tag";

export const FILTERS_LIST = gql`
  query getFiltersList {
    filters {
      price {
        tagId
        title
        description
        icon
        values
        propertyField
        type
      }
      entities {
        tagId
        title
        description
        icon
        values
        propertyField
        type
      }
    }
  }
`;

export const FILTERS_VALUES = gql`
  query userFilters {
    userFilters {
      address {
        placeId
      }
      filters {
        tagId
        value
      }
    }
  }
`;
